import create from 'zustand'
import algoliaSearch from 'algoliasearch/lite'

import { config } from '~helpers/config'

// Puts search client in global scope we can use to interact with later without instantiating again
const useAlgoliaSearchClient = create(() => ({
  searchClient: algoliaSearch(
    config.algolia.applicationId,
    config.algolia.apiKey
  ),
}))

export default useAlgoliaSearchClient
